import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService, IMessageModel } from '@tencentcloud/chat-uikit-engine';
import { ref, computed, withDefaults } from '../../../../../adapter-vue';
import { CHAT_MSG_CUSTOM_TYPE } from '../../../../../constant';
import { JSONToObject, isUrl } from '../../../../../utils/index';
import Icon from '../../../../common/Icon.vue';
import star from '../../../../../assets/icon/star-light.png';
import { IHighlightContent } from '../../../type';
import { ISearchResultListItem } from '../../../../../interface';
interface IProps {
  contentText: IHighlightContent[];
  message: IMessageModel | ISearchResultListItem;
  messageContent: Record<string, unknown> | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-custom',
  props: {
    contentText: { default: () => ([]) as IHighlightContent[] },
    message: { default: () => ({}) as IMessageModel },
    messageContent: { default: () => ({}) as Record<string, unknown> }
  },
  setup(__props: any) {

const props = __props as { contentText: IHighlightContent[], message: IMessageModel | ISearchResultListItem, messageContent: Record<string, unknown> | undefined }



const custom = ref<{ data?: string; description?: string; extension?: string }>(
  (props?.message as IMessageModel)?.payload,
);
const extensionJSON = computed(() => custom?.value?.data ? JSONToObject(custom.value.data) : custom?.value?.data);
const businessID = computed(() => extensionJSON?.value?.businessID);
const descriptionForShow = ref<Array<{ text: string; isHighlight: boolean }>>(props?.contentText);
const defaultMessageContent = ref<string>(props?.messageContent?.custom as string || '[自定义消息]');

return { __sfc: true,props, custom, extensionJSON, businessID, descriptionForShow, defaultMessageContent, TUITranslateService, CHAT_MSG_CUSTOM_TYPE, isUrl, Icon, star }
}

})